import React from 'react';
import { connect } from 'react-redux';
import Carousel from './Carousel';
import compose from '../../../../src/web/utils/react/compose';
import { getCompanyId } from '../../../../src/web/store/modules/company';
import imageWidget from '../../../../src/web/components/widgets/decorators/imageWidget';
import { NAME, ID } from './properties';
import styles from './styles.scss';

const component = compose(
  connect(
    state => ({
      companyId: getCompanyId(state),
    }),
  ),
  imageWidget(
    { name: NAME, category: 'Images', componentId: ID, deprecated: true },
    {
      menu: {
        items: [{
          label: (
            <div className={styles.contextMessage}>
              This is widget cannot be deleted.
              Modify the images by editing the parent section.
            </div>
          ),
        }],
      },
    },
  ),
)(Carousel);

export default component;
